import Logo from "shared/branding/logo.svg?url";
import { Button, ButtonVariant } from "shared/components";
import {
  ArrowRight01Icon,
  PartyIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const EndSurveySlice = ({
  onUpsellClick
}: {
  onUpsellClick?: () => void;
}) => {
  return (
    <div className="flex flex-col h-full">
      <div className="shrink-0 px-6 py-4">
        <img src={Logo} className="h-8" alt="Boom" />
      </div>
      {/* mock filled progress bar */}
      <div className="w-full h-1 bg-primary-500" />

      <main className="flex-grow flex flex-col items-center justify-center bg-background-900 px-4">
        <div className="size-[100px] rounded-full bg-primary-50 flex items-center justify-center mb-6">
          <HugeiconsIcon
            icon={PartyIcon}
            size={40}
            strokeWidth={1}
            className="text-primary-500"
          />
        </div>

        <h1 className="text-xl font-bold text-content-1000 mb-2 text-center">
          You just helped verify a tenant&apos;s rental history
        </h1>

        <p className="text-sm text-content-300 mb-8 text-center">
          Fast, compliant, and built for property managers—that&apos;s
          BoomScreen
        </p>

        <Button
          variant={ButtonVariant.PRIMARY}
          HugeIcon={ArrowRight01Icon}
          iconPosition="right"
          onClick={onUpsellClick}
        >
          See how it works
        </Button>
      </main>
    </div>
  );
};
